<template>
  <div class="dropdown-button">
    <button
      id="user-dropdown-launcher"
      role="menuitem"
      aria-haspopup="true"
      aria-controls="app-bar-account-menu"
      :aria-expanded="xUserMenu"
      class="app-bar-button"
      :title="__('Account')"
      @click="showUserMenu"
    >
      <avatar-image :user="user" :width="20" :height="20" />
    </button>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { mapActions, mapState } from 'vuex'
import AvatarImage from 'vuecomponents/avatar_image'
import EscapeToCancelMixin from 'vuemixins/escape_to_cancel_mixin'

export default {
  name: 'AppBarAccount',
  components: {
    AvatarImage,
  },
  mixins: [EscapeToCancelMixin],
  props: ['user'],
  computed: {
    ...mapState('appBarAccount', ['xUserMenu']),
  },
  methods: {
    ...mapActions('appBarAccount', ['showUserMenu', 'hideUserMenu']),
    cancel() {
      this.hideUserMenu()
    },
  },
}
</script>
